import { TCancelOrder } from "@features/Order/type/TCancelOrder";
import { useOrderList } from "@features/Order/hook/useOrderList";

interface IParams {
    parentCancelOrder: TCancelOrder;
}

export const useCurrentOrder = (props: IParams) => {
    const { parentCancelOrder } = props;
    const { orderList, getOrdersState, getOrders } = useOrderList();

    const cancelOrder: TCancelOrder = async (orderReference) => {
        try {
            await parentCancelOrder(orderReference);
            getOrders();
        } catch (error) {
            // TODO GAW-304
        }
    };

    return { cancelOrder, orderList, getOrdersState, getOrders };
};
